var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-wrap" }, [
    _c(
      "div",
      { staticClass: "loginwrap", staticStyle: { width: "100%" } },
      [
        _c(
          "el-row",
          {
            attrs: {
              gutter: 20,
              type: "flex",
              justify: "space-between",
              align: "bottom",
            },
          },
          [
            _c("el-col", { attrs: { span: 12 } }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("auth.login.title")))]),
            ]),
            _vm._v(" "),
            _vm.currentAward
              ? _c(
                  "el-col",
                  { staticClass: "text-right", attrs: { span: 12 } },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "blacklink",
                        attrs: { to: _vm.registerLink },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("auth.register.title")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("login-form", {
          attrs: { errors: _vm.authErrors, loading: _vm.loading },
          on: { submit: _vm.onSubmit },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }